import {ListParams} from '../../Components/List/hooks'
import {Filter, Tab} from '../../Components/Filters/types'

export type WEBSITE_STATE = ListParams

export const WEBSITE_TABS: ReadonlyArray<Tab> = [
  {label: 'All Sites', value: 'all'},
  {label: 'Enabled', value: 'enabled'},
  {label: 'Disabled', value: 'disabled'},
]

export const INIT_WEBSITE_STATE: WEBSITE_STATE = {
  page: 1,
  tab: WEBSITE_TABS[0].value,
  searchTerm: '',
  sort: null,
}
export const WEBSITE_FILTERS: ReadonlyArray<Filter<WEBSITE_STATE>> = [
  {
    displayName: 'Sort By',
    fieldName: 'sort',
    type: 'radio',
    options: [
      { name: 'Name Z-A', value: { sortBy: 'name', order: 'DESC' } },
      { name: 'Name A-Z', value: { sortBy: 'name', order: 'ASC' } },
    ],
  },
]
